import React from 'react';
import { Button } from '@material-ui/core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IProductReturnVisualizerProps } from './interfaces';

export const ProductReturnVisualizer = ({ row, router }: IProductReturnVisualizerProps) => {
  return (
    <Button onClick={() => router.push(`/qualidade/devolucao/relatorio/${row.personId}/${row.returnReceiptId}`)}>
      <FontAwesomeIcon icon={faEye} size="2x" />
    </Button>
  );
};
